export const Style = ({ colors = [] }) => (
  <g id="Estilo2" style={{ opacity: '0.6' }}>
    <path
      style={{ display: 'inline', fill: colors[0] }}
      d="M78.7,70c0,1.9-1.3,3.4-2.9,3.4s-2.9-1.5-2.9-3.4s1.3-6.9,2.9-6.9 S78.7,68.1,78.7,70z"
    />
  </g>
)
